<template>
  <div class="card no-border">
    <div v-if="item.image" class="card-image">
      <img :src="item.image">
    </div>
    <div class="card-section">
      <h3>{{ item.title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    styles () {
      let obj = {}
      if (this.item.image) {
        obj.backgroundImage = 'url(' + this.item.image +')'
      }
      return obj
    }
  }
}
</script>
